"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const ConfirmationStep_1 = __importDefault(require("@Components/CreateWorkBottomNavs/ConfirmSubmission/ConfirmationStep"));
const OverclaimWarningStep_1 = __importDefault(require("@Components/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep"));
const ConfirmSubmission = (props) => {
    const { isSideBarOpen, closeSidebar, step, onClickConfirmOverclaim } = props;
    return (react_1.default.createElement(ModalPortal_1.default, { isOpen: isSideBarOpen, onClose: closeSidebar }, step === 'overclaim' ? (onClickConfirmOverclaim && (react_1.default.createElement(OverclaimWarningStep_1.default, { onClickConfirm: onClickConfirmOverclaim, onClickCancel: closeSidebar }))) : (react_1.default.createElement(ConfirmationStep_1.default, Object.assign({}, props)))));
};
exports.default = ConfirmSubmission;
